export function decodeToRealUserId(obfuscatedId: string | number, email: string): string | undefined {
  if (!obfuscatedId || !email) {
    return undefined;
  }

  const code = email.charCodeAt(0) + '';
  const xor = parseInt(code, 10).toString(2);
  const actual_id = Number(obfuscatedId) ^ +xor;

  return actual_id + '';
}

export function humanize(value: string): string {
  if (!value) {
    return '';
  }

  return value.split('_').map(capitalize).join(' ');
}

export function capitalize(value: string): string {
  if (!value) {
    return '';
  }

  return value.charAt(0).toUpperCase() + value.slice(1);
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const dedupeArray = (arr: any[]) => Array.from(new Set(arr));

export class Logger {
  /**
   * High contrast log for logs containing information about concrete events
   * @param msg
   */
  static log(...msg: unknown[]) {
    // eslint-disable-next-line no-console
    console.log(`%c ${msg}`, 'background: #230b41; color: #ed3c6a');
  }

  static debug(...msg: unknown[]) {
    // eslint-disable-next-line no-console
    console.debug(msg);
  }

  /**
   * Slightly more muted log for logs containing read only information, like that a service initialized
   * @param msg
   */
  static info(...msg: unknown[]) {
    // eslint-disable-next-line no-console
    console.info(`%c ${msg}`, 'background: #f6f0ff; color: #9571c3');
  }

  static error(...msg: unknown[]) {
    // eslint-disable-next-line no-console
    console.error(`%c ${msg}`, 'background: #f6f0ff; color: #9571c3');
  }
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function isArray(value: any): value is any[] {
  return Array.isArray(value);
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function ConvertEnumToArray<E>(enumObject: any): E {
  const array = [];

  for (const [propertyKey, propertyValue] of Object.entries(enumObject)) {
    if (!Number.isNaN(Number(propertyKey))) {
      continue;
    }

    if (propertyValue === '') {
      continue;
    }
    array.push(propertyValue);
  }

  return array as unknown as E;
}

export const logAppVersion = (name: string, version: string) => {
  Logger.log(`Hospitable (${name}) - ${version}`);
};

export const openInNewWindow = (url: string) => {
  try {
    // Open window immediately to work on iOS
    const newWindow = window.open('about:blank', '_blank');
    if (newWindow) {
      newWindow.location.href = url;
    } else {
      window.location.href = url;
    }
    setTimeout(() => URL.revokeObjectURL(url), 1000);
  } catch {
    // Silently handle error - popup may have been blocked
  }
};

export function toKebabCase(value: string): string {
  if (!value) {
    return '';
  }

  return (
    value
      // Replace underscores with hyphens
      .replace(/_/g, '-')
      // Add hyphen before uppercase letters, but not at the beginning
      .replace(/([a-z])([A-Z])/g, '$1-$2')
      .toLowerCase()
  );
}

export function determineStartOfWeekPreference(weekStartsOn: string | null): number {
  if (!weekStartsOn) {
    // Preference has not been set, fall back to brower locale:
    // `en-US` → `sunday`
    // `<any other>` → `monday`
    if (navigator?.language.toLowerCase() === 'en-us') {
      return 0;
    } else {
      return 1;
    }
  }
  return weekStartsOn === 'sunday' ? 0 : 1;
}
